<template>
  <avs-chip
    class="min-width-120"
    color="success"
    icon="mdi-check-circle-outline"
    iconColor="white"
    text-color="white"
  >
    {{ $t("commons.status.closed") }}
  </avs-chip>
</template>

<script>
export default {
  name: "ClosedChip"
}
</script>
